module.exports = __webpack_public_path__ + "static/media/plus-blue.bd9529c2.svg";